import React, { useEffect, useMemo, useState } from 'react';
import { db } from '../../firebase';
import {
  collection,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from 'firebase/firestore';
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';

const defaultCategories = [
  { slug: 'raquettes', name: 'Raquettes', order: 1 },
  { slug: 'chaussures', name: 'Chaussures', order: 2 },
  { slug: 'sacs', name: 'Sacs', order: 3 },
  { slug: 'textiles', name: 'Textiles', order: 4 },
  { slug: 'accessoires', name: 'Accessoires', order: 5 },
];

const defaultShopProducts = [
    {
      id: 1,
      name: "AT10 GENIUS 12K ALUM XTREM BY AGUSTIN TAPIA",
      price: 389.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-at10-genius-12k-alum-xtrem.png",
      category: "Raquettes",
    },
    {
      id: 2,
      name: "AT10 GENIUS ATTACK 12K ALUM XTREM BY AGUSTIN TAPIA",
      price: 359.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-at10-genius-attack-12k-alum-xtrem.png",
      category: "Raquettes",
    },
    {
      id: 3,
      name: "AT10 GENIUS 18K ALUM BY AGUSTIN TAPIA",
      price: 389.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-at10-genius-18k-alum.png",
      category: "Raquettes",
    },
    {
      id: 4,
      name: "AT10 GENIUS ATTACK 18K ALUM BY AGUSTIN TAPIA",
      price: 359.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-at10-genius-attack-18k-alum.png",
      category: "Raquettes",
    },
    {
      id: 5,
      name: "EA10 VENTUS HYBRID 12K XTREM BY EDU ALONSO",
      price: 339.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-ea10-ventus-hybrid-12k-xtrem.png",
      category: "Raquettes",
    },
    {
      id: 6,
      name: "EA10 VENTUS ATTACK 12K XTREM BY EDU ALONSO",
      price: 339.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-ea10-ventus-attack-12k-xtrem.png",
      category: "Raquettes",
    },
    {
      id: 7,
      name: "ML10 VENTUS CONTROL 3K BY MIGUEL LAMPERTI",
      price: 339.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-ml10-ventus-control-3k.png",
      category: "Raquettes",
    },
    {
      id: 8,
      name: "VK10 VENTUS CONTROL 12K BY ARANZAZU OSORO",
      price: 299.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-vk10-ventus-control-12k.png",
      category: "Raquettes",
    },
    {
      id: 9,
      name: "VENTUS HYBRID 12K LITE",
      price: 299.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-ventus-hybrid-12k-lite.png",
      category: "Raquettes",
    },
    {
      id: 10,
      name: "FUTURE ATTACK 12K ALUM",
      price: 269.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-future-attack-12k-alum.png",
      category: "Raquettes",
    },
    {
      id: 11,
      name: "FUTURE HYBRID 12K ALUM",
      price: 269.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-future-hybrid-12k-alum.png",
      category: "Raquettes",
    },
    {
      id: 12,
      name: "FUTURE CONTROL 12K ALUM",
      price: 269.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-future-control-12k-alum.png",
      category: "Raquettes",
    },
    {
      id: 13,
      name: "AT10 LUX BLACK / WHITE",
      price: 124.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-lux-black-white.png",
      category: "Chaussures",
      sizes: ["40", "41"],
    },
    {
      id: 14,
      name: "AT10 LUX FEATHER GRAY / RAVEN",
      price: 124.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-lux-feather-gray-raven.png",
      category: "Chaussures",
      sizes: ["46", "47", "48"],
    },
    {
      id: 15,
      name: "AT10 LUX MORNING MIST / TURQUOISE",
      price: 124.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-lux-morning-mist-turquoise.png",
      category: "Chaussures",
      sizes: ["39", "40", "41", "42"],
    },
    {
      id: 16,
      name: "AT10 LUX DARK SLATE / ALLURE",
      price: 124.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-lux-dark-slate-allure.png",
      category: "Chaussures",
      sizes: ["39", "40", "41", "42", "43", "45", "46", "47", "48"],
    },
    {
      id: 17,
      name: "AT10 PRO BLACK / WHITE",
      price: 99.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-pro-black-white.png",
      category: "Chaussures",
      sizes: ["39", "41", "42", "43", "44"],
    },
    {
      id: 18,
      name: "AT10 PRO SILVER BIRCH / BLACK",
      price: 99.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-pro-silver-birch-black.png",
      category: "Chaussures",
      sizes: ["39", "41", "42", "43", "44", "45", "46"],
    },
    {
      id: 19,
      name: "AT10 PRO SEA CORAL / WHITE",
      price: 99.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-pro-sea-coral-white.png",
      category: "Chaussures",
      sizes: ["36", "37", "38", "39", "40", "41", "42"],
    },
    {
      id: 20,
      name: "AT10 PRO ASPARAGUS / FROSTY GREEN",
      price: 99.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-pro-asparagus-frosty-green.png",
      category: "Chaussures",
      sizes: ["39", "40", "41", "42"],
    },
    {
      id: 21,
      name: "AT10 PRO PURPLE / WHITE",
      price: 99.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-pro-purple-white.png",
      category: "Chaussures",
      sizes: ["38", "39", "40", "41", "42"],
    },
    {
      id: 22,
      name: "AT10 PRO TURQUOISE / WHITE",
      price: 99.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-at10-pro-turquoise-white.png",
      category: "Chaussures",
      sizes: ["39", "40", "41", "42", "43", "44", "45", "46", "47"],
    },
    {
      id: 23,
      name: "ML10 HEXA BLACK / WHITE",
      price: 114.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-ml10-hexa-black-white.png",
      category: "Chaussures",
      sizes: ["40", "41", "42", "43", "44", "45", "46", "47"],
    },
    {
      id: 24,
      name: "NERBO WHITE / DUSK BLUE",
      price: 119.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "chaussure-nerbo-white-dusk-blue.png",
      category: "Chaussures",
      sizes: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48"],
    },
    {
      id: 25,
      name: "AT10 COMPETITION TROLLEY",
      price: 119.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-at10-competition-trolley.png",
      category: "Sacs",
    },
    {
      id: 27,
      name: "ML10 COMPETITION XL COMPACT PADELBAG",
      price: 79.95,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-ml10-competition-xl-compact.png",
      category: "Sacs",
    },
    {
      id: 28,
      name: "PRO SERIES BLUE BACKPACK",
      price: 54.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-pro-series-blue-backpack.png",
      category: "Sacs",
    },
    {
      id: 29,
      name: "PRO SERIES CAMEL BACKPACK",
      price: 54.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-pro-series-camel-backpack.png",
      category: "Sacs",
    },
    {
      id: 30,
      name: "ML10 TEAM WHITE / GREY PADELBAG",
      price: 69.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-ml10-team-white-grey-padelbag.png",
      category: "Sacs",
    },
    {
      id: 31,
      name: "ML10 TEAM BLACK / CLAY PADELBAG",
      price: 69.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-ml10-team-black-clay-padelbag.png",
      category: "Sacs",
    },
    {
      id: 32,
      name: "ML10 TEAM BLACK / BLUE PADELBAG",
      price: 69.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "sac-ml10-team-black-blue-padelbag.png",
      category: "Sacs",
    },
    {
      id: 38,
      name: "MEN'S TEAM RED T-SHIRT",
      price: 44.95,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-red-tshirt.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 39,
      name: "MEN'S TEAM REGULAR GREY T-SHIRT",
      price: 44.95,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-regular-grey-tshirt.png",
      category: "Textiles",
      sizes: ["M", "L", "XL", "XXL"],
    },
    {
      id: 40,
      name: "MEN'S TEAM REGULAR DARK BLUE T-SHIRT",
      price: 44.95,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-regular-dark-blue-tshirt.png",
      category: "Textiles",
      sizes: ["S", "XL", "XXL"],
    },
    {
      id: 42,
      name: "MEN'S TEAM REGULAR WHITE POLO SHIRT",
      price: 49.95,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-regular-white-polo.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 43,
      name: "MEN'S TEAM DARK BLUE SHORTS",
      price: 49.95,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-dark-blue-shorts.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 45,
      name: "MEN'S SWEATSHIRT STEEL GREY",
      price: 69.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-sweatshirt-steel-grey.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 46,
      name: "SOFTSHELL NOX TEAM BLACK MEN",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-softshell-nox-team-black-men.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 48,
      name: "MEN'S PADDED JACKET TEAM BLACK",
      price: 79.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-padded-jacket-team-black.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 51,
      name: "MEN'S TEAM BLACK PANTS",
      price: 59.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-black-pants.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 52,
      name: "MEN'S TEAM NAVY BLUE PANTS",
      price: 59.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-navy-blue-pants.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 53,
      name: "MEN'S TEAM MOON GREY PANTS",
      price: 59.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-mens-team-moon-grey-pants.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 54,
      name: "SOFTSHELL NOX TEAM BLACK MEN",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-softshell-nox-team-black-men.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 55,
      name: "NOX TEAM RED MEN'S SOFTSHELL",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-softshell-nox-team-red-men.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 56,
      name: "SOFTSHELL NOX TEAM MOONLIGHT BLUE WOMEN",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-softshell-nox-team-moonlight-blue-men.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 57,
      name: "SOFTSHELL NOX TEAM PALE GREY MEN",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "textile-softshell-nox-team-pale-grey-men.png",
      category: "Textiles",
      sizes: ["S", "M", "L", "XL", "XXL"],
    },
    {
      id: 58,
      name: "X-ZERO RED",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-x-zero-red.png",
      category: "Raquettes",
    },
    {
      id: 59,
      name: "X-ZERO BLUE",
      price: 74.99,
      discountRate: 0,
      discountEligible: false,
      line: "NOX",
      image: "raquette-x-zero-blue.png",
      category: "Raquettes",
    },
    {
      id: 125,
      name: "CARTON DE BALLE NOX",
      price: 115,
      discountRate: 0,
      discountEligible: true,
      line: "NOX",
      image: "balle.png",
      description: "Carton contenant 24 tubes de balle Nox nouvelle génération",
      category: "Accessoires",
    },
  ];

const emptyProductForm = {
  id: '',
  name: '',
  sku: '',
  price: 0,
  discountRatePercent: 0,
  discountEligible: false,
  line: 'NOX',
  image: '',
  categorySlug: 'raquettes',
  description: '',
  sizesText: '',
  featuresText: '',
  stockStatus: 'available',
  featured: false,
  sortOrder: 0,
  visible: true,
  archived: false,
};

const emptyCategoryForm = {
  slug: '',
  name: '',
  order: 1,
  visible: true,
  archived: false,
};

const slugify = (value) => {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const parseCommaList = (value) => {
  const clean = String(value || '').trim();

  if (!clean) return undefined;

  return clean
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

const stringifyCommaList = (value) => {
  if (!Array.isArray(value)) return '';
  return value.join(', ');
};

const parseFeatures = (value) => {
  const clean = String(value || '').trim();

  if (!clean) return undefined;

  return clean
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [icon, ...textParts] = line.split('|');
      const text = textParts.join('|').trim();

      if (!text) {
        return {
          icon: '•',
          text: line,
        };
      }

      return {
        icon: icon.trim() || '•',
        text,
      };
    });
};

const stringifyFeatures = (value) => {
  if (!Array.isArray(value)) return '';

  return value
    .map((feature) => `${feature.icon || '•'}|${feature.text || ''}`)
    .join('\n');
};

const priceAfterDiscount = (product) => {
  const price = Number(product.price || 0);
  const discountRate = Number(product.discountRate || 0);

  if (!product.discountEligible) return price;

  return Number((price * (1 - discountRate)).toFixed(2));
};

const AdminShopCatalog = () => {
  const [productForm, setProductForm] = useState(emptyProductForm);
  const [categoryForm, setCategoryForm] = useState(emptyCategoryForm);

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [search, setSearch] = useState('');
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loading, setLoading] = useState(false);

  const [imageFile, setImageFile] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const isBusy = loading || uploadingImage;

  const loadCategories = async () => {
    try {
      setLoadingCategories(true);

      const snapshot = await getDocs(collection(db, 'shop_categories'));

      const data = snapshot.docs
        .map((docSnap) => ({
          ...docSnap.data(),
          _docId: docSnap.id,
          slug: docSnap.data().slug || docSnap.id,
        }))
        .sort((a, b) => Number(a.order || 0) - Number(b.order || 0));

      setCategories(data);
    } catch (error) {
      console.error('Erreur chargement shop_categories:', error);
      alert('Erreur lors du chargement des catégories.');
    } finally {
      setLoadingCategories(false);
    }
  };

  const loadProducts = async () => {
    try {
      setLoadingProducts(true);

      const snapshot = await getDocs(collection(db, 'shop_products'));

      const data = snapshot.docs
        .map((docSnap) => {
          const data = docSnap.data();

          return {
            ...data,
            _docId: docSnap.id,
            id: Number(data.id ?? docSnap.id),
          };
        })
        .sort((a, b) => {
          const orderA = Number(a.sortOrder || a.id || 0);
          const orderB = Number(b.sortOrder || b.id || 0);

          if (orderA !== orderB) return orderA - orderB;

          return Number(a.id || 0) - Number(b.id || 0);
        });

      setProducts(data);
    } catch (error) {
      console.error('Erreur chargement shop_products:', error);
      alert('Erreur lors du chargement des produits.');
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    loadCategories();
    loadProducts();
  }, []);

  const activeCategories = useMemo(() => {
    return categories.filter(
      (category) => category.archived !== true && category.visible !== false
    );
  }, [categories]);

  const nextProductId = useMemo(() => {
    if (!products.length) return 1;

    return Math.max(...products.map((product) => Number(product.id || 0)), 0) + 1;
  }, [products]);

  const nextCategoryOrder = useMemo(() => {
    if (!categories.length) return 1;

    return Math.max(...categories.map((category) => Number(category.order || 0)), 0) + 1;
  }, [categories]);

  const filteredProducts = useMemo(() => {
    const term = search.trim().toLowerCase();

    if (!term) return products;

    return products.filter((product) => (
      String(product.id || '').includes(term) ||
      String(product.name || '').toLowerCase().includes(term) ||
      String(product.sku || '').toLowerCase().includes(term) ||
      String(product.category || '').toLowerCase().includes(term) ||
      String(product.categorySlug || '').toLowerCase().includes(term) ||
      String(product.line || '').toLowerCase().includes(term)
    ));
  }, [products, search]);

  const getCategoryName = (categorySlug) => {
    const found = categories.find((category) => category.slug === categorySlug);

    return found?.name || categorySlug || 'Sans catégorie';
  };

  const getCategoryUsageCount = (category) => {
    return products.filter((product) => {
      const productSlug = product.categorySlug || slugify(product.category);

      return productSlug === category.slug;
    }).length;
  };

  const getProductDocId = (product) => {
    return String(product._docId || product.id);
  };

  const scrollToProductForm = () => {
    setTimeout(() => {
      document
        .getElementById('admin-shop-product-form')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  };

  const scrollToCategoryForm = () => {
    setTimeout(() => {
      document
        .getElementById('admin-shop-category-form')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  };

  const resetProductForm = () => {
    setProductForm({
      ...emptyProductForm,
      categorySlug: activeCategories[0]?.slug || 'raquettes',
    });
    setImageFile(null);
  };

  const resetCategoryForm = () => {
    setCategoryForm({
      ...emptyCategoryForm,
      order: nextCategoryOrder,
    });
  };

  const setNextProduct = () => {
    setProductForm((prev) => ({
      ...prev,
      id: nextProductId,
      name: '',
      sku: '',
      price: 0,
      categorySlug: activeCategories[0]?.slug || 'raquettes',
      sortOrder: nextProductId,
      visible: true,
      archived: false,
    }));

    setImageFile(null);
    scrollToProductForm();
  };

  const handleProductChange = (e) => {
    const { name, value, type, checked } = e.target;

    setProductForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleCategoryChange = (e) => {
    const { name, value, type, checked } = e.target;

    setCategoryForm((prev) => {
      const next = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };

      if (name === 'name') {
        next.slug = slugify(value);
      }

      return next;
    });
  };

  const seedDefaultCategories = async () => {
    const confirmSeed = window.confirm(
      'Créer les catégories de base dans shop_categories ?'
    );

    if (!confirmSeed) return;

    try {
      setLoading(true);

      for (const category of defaultCategories) {
        await setDoc(
          doc(db, 'shop_categories', category.slug),
          {
            ...category,
            visible: true,
            archived: false,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );
      }

      alert('✅ Catégories de base créées.');
      await loadCategories();
    } catch (error) {
      console.error('Erreur création catégories:', error);
      alert('Erreur lors de la création des catégories.');
    } finally {
      setLoading(false);
    }
  };

  const saveCategory = async (e) => {
    e.preventDefault();

    const slug = slugify(categoryForm.slug || categoryForm.name);

    if (!slug) {
      alert('Slug catégorie obligatoire.');
      return;
    }

    if (!categoryForm.name.trim()) {
      alert('Nom de catégorie obligatoire.');
      return;
    }

    try {
      setLoading(true);

      await setDoc(
        doc(db, 'shop_categories', slug),
        {
          slug,
          name: categoryForm.name.trim(),
          order: Number(categoryForm.order || 0),
          visible: Boolean(categoryForm.visible),
          archived: Boolean(categoryForm.archived),
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      alert(`✅ Catégorie ${categoryForm.name} enregistrée.`);

      resetCategoryForm();
      await loadCategories();
    } catch (error) {
      console.error('Erreur sauvegarde catégorie:', error);
      alert('Erreur lors de la sauvegarde de la catégorie.');
    } finally {
      setLoading(false);
    }
  };

  const editCategory = (category) => {
    setCategoryForm({
      slug: category.slug || '',
      name: category.name || '',
      order: category.order ?? 1,
      visible: category.visible ?? true,
      archived: category.archived ?? false,
    });

    scrollToCategoryForm();
  };

  const archiveCategory = async (category) => {
    const usageCount = getCategoryUsageCount(category);

    const confirmArchive = window.confirm(
      usageCount > 0
        ? `Archiver la catégorie ${category.name} ? ${usageCount} produit(s) utilisent encore cette catégorie.`
        : `Archiver la catégorie ${category.name} ?`
    );

    if (!confirmArchive) return;

    try {
      setLoading(true);

      await setDoc(
        doc(db, 'shop_categories', category.slug),
        {
          archived: true,
          visible: false,
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      await loadCategories();
    } catch (error) {
      console.error('Erreur archivage catégorie:', error);
      alert("Erreur lors de l'archivage de la catégorie.");
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (category) => {
    const usageCount = getCategoryUsageCount(category);

    if (usageCount > 0) {
      alert(
        `Impossible de supprimer cette catégorie : ${usageCount} produit(s) l’utilisent encore. Archive-la plutôt ou change d’abord la catégorie des produits.`
      );
      return;
    }

    const confirmDelete = window.confirm(
      `Supprimer définitivement la catégorie ${category.name} ?`
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      await deleteDoc(doc(db, 'shop_categories', category.slug));

      await loadCategories();
    } catch (error) {
      console.error('Erreur suppression catégorie:', error);
      alert('Erreur lors de la suppression de la catégorie.');
    } finally {
      setLoading(false);
    }
  };

  const uploadProductImage = async () => {
    if (!imageFile) {
      return productForm.image.trim();
    }

    if (!productForm.id) {
      alert("Mets d'abord un ID produit avant d'uploader une image.");
      return null;
    }

    try {
      setUploadingImage(true);

      const storage = getStorage(
        undefined,
        'gs://mendyx-adafe.firebasestorage.app'
      );

      const extension = imageFile.name.split('.').pop() || 'jpg';

      const cleanName = imageFile.name
        .replace(/\.[^/.]+$/, '')
        .replace(/[^a-zA-Z0-9-_]/g, '-')
        .toLowerCase();

      const fileName = `shop-product-${productForm.id}-${Date.now()}-${cleanName}.${extension}`;

      const storageRef = ref(
        storage,
        `shop/products/${productForm.id}/${fileName}`
      );

      await uploadBytes(storageRef, imageFile, {
        contentType: imageFile.type || 'image/jpeg',
      });

      const downloadURL = await getDownloadURL(storageRef);

      setProductForm((prev) => ({
        ...prev,
        image: downloadURL,
      }));

      setImageFile(null);

      return downloadURL;
    } catch (error) {
      console.error('Erreur upload image produit:', error);
      alert("Erreur lors de l'upload de l'image produit.");
      return null;
    } finally {
      setUploadingImage(false);
    }
  };

  const validateProductForm = () => {
    if (!productForm.id) return 'ID obligatoire.';
    if (!productForm.name.trim()) return 'Nom obligatoire.';
    if (!productForm.categorySlug.trim()) return 'Catégorie obligatoire.';
    if (!productForm.price) return 'Prix obligatoire.';

    if (!productForm.image.trim() && !imageFile) {
      return 'Image obligatoire. Mets un nom de fichier ou upload une image.';
    }

    if (Number(productForm.discountRatePercent) < 0 || Number(productForm.discountRatePercent) > 100) {
      return 'La remise doit être entre 0 et 100%.';
    }

    return null;
  };

  const buildProductPayload = (imageUrl) => {
    const categoryName = getCategoryName(productForm.categorySlug);
    const sizes = parseCommaList(productForm.sizesText);
    const features = parseFeatures(productForm.featuresText);

    const payload = {
      id: Number(productForm.id),
      name: productForm.name.trim(),
      sku: productForm.sku.trim(),
      price: Number(productForm.price),
      discountRate: Number(productForm.discountRatePercent || 0) / 100,
      discountEligible: Boolean(productForm.discountEligible),
      line: productForm.line.trim(),
      image: imageUrl,
      categorySlug: productForm.categorySlug.trim(),
      category: categoryName,
      description: productForm.description.trim(),
      stockStatus: productForm.stockStatus,
      featured: Boolean(productForm.featured),
      sortOrder: Number(productForm.sortOrder || productForm.id),
      visible: Boolean(productForm.visible),
      archived: Boolean(productForm.archived),
      updatedAt: serverTimestamp(),
    };

    if (sizes && sizes.length > 0) {
      payload.sizes = sizes;
    } else {
      payload.sizes = [];
    }

    if (features && features.length > 0) {
      payload.features = features;
    } else {
      payload.features = [];
    }

    return payload;
  };

  const saveProduct = async (e) => {
    e.preventDefault();

    const errorMessage = validateProductForm();

    if (errorMessage) {
      alert(errorMessage);
      return;
    }

    try {
      setLoading(true);

      const imageUrl = await uploadProductImage();

      if (!imageUrl) return;

      const payload = buildProductPayload(imageUrl);
      const documentId = String(payload.id);

      await setDoc(
        doc(db, 'shop_products', documentId),
        payload,
        { merge: true }
      );

      alert(`✅ Produit ${payload.id} enregistré.`);

      resetProductForm();
      await loadProducts();
    } catch (error) {
      console.error('Erreur sauvegarde produit:', error);
      alert("Erreur lors de l'enregistrement du produit.");
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (product) => {
    setProductForm({
      id: product.id ?? '',
      name: product.name ?? '',
      sku: product.sku ?? '',
      price: product.price ?? 0,
      discountRatePercent: Number(product.discountRate || 0) * 100,
      discountEligible: product.discountEligible ?? false,
      line: product.line ?? 'NOX',
      image: product.image ?? '',
      categorySlug: product.categorySlug || slugify(product.category) || 'raquettes',
      description: product.description ?? '',
      sizesText: stringifyCommaList(product.sizes),
      featuresText: stringifyFeatures(product.features),
      stockStatus: product.stockStatus ?? 'available',
      featured: product.featured ?? false,
      sortOrder: product.sortOrder ?? product.id ?? 0,
      visible: product.visible ?? true,
      archived: product.archived ?? false,
    });

    setImageFile(null);
    scrollToProductForm();
  };

  const duplicateProduct = (product) => {
    setProductForm({
      id: nextProductId,
      name: product.name ? `${product.name} - copie` : '',
      sku: '',
      price: product.price ?? 0,
      discountRatePercent: Number(product.discountRate || 0) * 100,
      discountEligible: product.discountEligible ?? false,
      line: product.line ?? 'NOX',
      image: product.image ?? '',
      categorySlug: product.categorySlug || slugify(product.category) || 'raquettes',
      description: product.description ?? '',
      sizesText: stringifyCommaList(product.sizes),
      featuresText: stringifyFeatures(product.features),
      stockStatus: product.stockStatus ?? 'available',
      featured: product.featured ?? false,
      sortOrder: nextProductId,
      visible: true,
      archived: false,
    });

    setImageFile(null);
    scrollToProductForm();
  };

  const toggleProductVisibility = async (product) => {
    try {
      setLoading(true);

      await setDoc(
        doc(db, 'shop_products', getProductDocId(product)),
        {
          visible: !Boolean(product.visible),
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      await loadProducts();
    } catch (error) {
      console.error('Erreur visibilité produit:', error);
      alert('Erreur lors du changement de visibilité.');
    } finally {
      setLoading(false);
    }
  };

  const archiveProduct = async (product) => {
    const confirmArchive = window.confirm(
      `Archiver le produit ${product.id} ? Il ne sera plus visible dans la boutique.`
    );

    if (!confirmArchive) return;

    try {
      setLoading(true);

      await setDoc(
        doc(db, 'shop_products', getProductDocId(product)),
        {
          archived: true,
          visible: false,
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      await loadProducts();
    } catch (error) {
      console.error('Erreur archivage produit:', error);
      alert("Erreur lors de l'archivage.");
    } finally {
      setLoading(false);
    }
  };

  const deleteProduct = async (product) => {
    const confirmDelete = window.confirm(
      `Supprimer définitivement le produit ${product.id} ?`
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      await deleteDoc(doc(db, 'shop_products', getProductDocId(product)));

      await loadProducts();
    } catch (error) {
      console.error('Erreur suppression produit:', error);
      alert('Erreur lors de la suppression.');
    } finally {
      setLoading(false);
    }
  };

  const importDefaultProducts = async () => {
    const confirmImport = window.confirm(
      `Importer ${defaultShopProducts.length} produits dans shop_products ? Les produits existants avec le même ID seront mis à jour.`
    );
  
    if (!confirmImport) return;
  
    try {
      setLoading(true);
  
      const categoryMap = new Map();
  
      defaultShopProducts.forEach((product) => {
        const categoryName = product.category || 'Sans catégorie';
        const categorySlug = slugify(categoryName);
  
        if (!categoryMap.has(categorySlug)) {
          categoryMap.set(categorySlug, categoryName);
        }
      });
  
      let categoryOrder = 1;
  
      for (const [categorySlug, categoryName] of categoryMap.entries()) {
        await setDoc(
          doc(db, 'shop_categories', categorySlug),
          {
            slug: categorySlug,
            name: categoryName,
            order: categoryOrder,
            visible: true,
            archived: false,
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );
  
        categoryOrder += 1;
      }
  
      for (const product of defaultShopProducts) {
        const categoryName = product.category || 'Sans catégorie';
        const categorySlug = product.categorySlug || slugify(categoryName);
  
        const payload = {
          id: Number(product.id),
          name: product.name || '',
          sku: product.sku || '',
          price: Number(product.price || 0),
          discountRate: Number(product.discountRate || 0),
          discountEligible: Boolean(product.discountEligible),
          line: product.line || 'NOX',
          image: product.image || '',
          categorySlug,
          category: categoryName,
          description: product.description || '',
          sizes: Array.isArray(product.sizes) ? product.sizes : [],
          features: Array.isArray(product.features) ? product.features : [],
          stockStatus: product.stockStatus || 'available',
          featured: Boolean(product.featured),
          sortOrder: Number(product.sortOrder || product.id || 0),
          visible: product.visible ?? true,
          archived: product.archived ?? false,
          updatedAt: serverTimestamp(),
        };
  
        await setDoc(
          doc(db, 'shop_products', String(product.id)),
          payload,
          { merge: true }
        );
      }
  
      alert('✅ Produits actuels importés dans shop_products.');
  
      await loadCategories();
      await loadProducts();
    } catch (error) {
      console.error('Erreur import produits actuels:', error);
      alert("Erreur lors de l'import des produits actuels.");
    } finally {
      setLoading(false);
    }
  };

  const statusLabel = {
    available: 'Disponible',
    out_of_stock: 'Rupture',
    preorder: 'Précommande',
  };

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-[#4c2f8e]">
          Admin - Boutique
        </h1>

        <p className="text-gray-600 mt-2">
          Gère les catégories et les produits affichés dans la boutique.
        </p>

        <div className="mt-3 p-3 rounded-lg bg-purple-50 border border-purple-200 text-sm text-purple-800">
          Structure Firestore utilisée :
          <strong> shop_categories</strong> pour les catégories et
          <strong> shop_products</strong> pour les produits.
        </div>

        <div className="mt-4 flex flex-col md:flex-row gap-2">
          <button
            type="button"
            disabled={isBusy}
            onClick={seedDefaultCategories}
            className="px-4 py-2 rounded-full bg-green-600 text-white text-sm disabled:opacity-60"
          >
            Créer les catégories de base
          </button>

          <button
            type="button"
            disabled={isBusy}
            onClick={importDefaultProducts}
            className="px-4 py-2 rounded-full bg-[#4c2f8e] text-white text-sm disabled:opacity-60"
          >
            Importer les produits actuels
          </button>

          <button
            type="button"
            disabled={isBusy}
            onClick={setNextProduct}
            className="px-4 py-2 rounded-full bg-gray-900 text-white text-sm disabled:opacity-60"
          >
            Nouveau produit ID : {nextProductId}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mb-8">
        <form
          id="admin-shop-category-form"
          onSubmit={saveCategory}
          className="bg-white shadow-lg rounded-2xl p-4 md:p-6"
        >
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Catégories
          </h2>

          <div className="space-y-3">
            <div>
              <label className="block text-sm font-semibold mb-1">Nom</label>
              <input
                name="name"
                value={categoryForm.name}
                onChange={handleCategoryChange}
                className="w-full border rounded-lg p-2"
                placeholder="Raquettes"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1">Slug</label>
              <input
                name="slug"
                value={categoryForm.slug}
                onChange={handleCategoryChange}
                className="w-full border rounded-lg p-2"
                placeholder="raquettes"
                required
              />
              <p className="text-xs text-gray-500 mt-1">
                Utilisé comme identifiant technique.
              </p>
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1">Ordre</label>
              <input
                name="order"
                type="number"
                value={categoryForm.order}
                onChange={handleCategoryChange}
                className="w-full border rounded-lg p-2"
              />
            </div>

            <div className="flex items-center gap-2">
              <input
                name="visible"
                type="checkbox"
                checked={categoryForm.visible}
                onChange={handleCategoryChange}
              />
              <label>Visible</label>
            </div>

            <div className="flex items-center gap-2">
              <input
                name="archived"
                type="checkbox"
                checked={categoryForm.archived}
                onChange={handleCategoryChange}
              />
              <label>Archivée</label>
            </div>

            <button
              type="submit"
              disabled={isBusy}
              className="w-full bg-[#4c2f8e] text-white rounded-full py-2 font-semibold disabled:opacity-60"
            >
              Enregistrer la catégorie
            </button>

            <button
              type="button"
              onClick={resetCategoryForm}
              className="w-full bg-gray-200 text-gray-800 rounded-full py-2 font-semibold"
            >
              Vider catégorie
            </button>
          </div>
        </form>

        <div className="xl:col-span-2 bg-white shadow-lg rounded-2xl p-4 md:p-6">
          <div className="flex items-center justify-between gap-3 mb-4">
            <h2 className="text-xl font-bold text-gray-800">
              Liste des catégories
            </h2>

            {loadingCategories && (
              <span className="text-sm text-gray-500">Chargement...</span>
            )}
          </div>

          {categories.length === 0 ? (
            <p className="text-gray-500">
              Aucune catégorie. Clique sur “Créer les catégories de base”.
            </p>
          ) : (
            <div className="space-y-3">
              {categories.map((category) => {
                const usageCount = getCategoryUsageCount(category);

                return (
                  <div
                    key={category.slug}
                    className={`border rounded-xl p-4 ${
                      category.archived ? 'bg-gray-100 opacity-70' : 'bg-white'
                    }`}
                  >
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                      <div>
                        <div className="font-bold text-[#4c2f8e]">
                          {category.order}. {category.name}
                        </div>

                        <div className="text-xs text-gray-500 mt-1">
                          Slug : {category.slug} | Produits : {usageCount}
                        </div>

                        <div className="text-xs text-gray-500 mt-1">
                          Visible : {category.visible ? 'oui' : 'non'} | Archivée : {category.archived ? 'oui' : 'non'}
                        </div>
                      </div>

                      <div className="flex flex-wrap gap-2">
                        <button
                          type="button"
                          disabled={isBusy}
                          onClick={() => editCategory(category)}
                          className="px-3 py-2 rounded-lg bg-blue-600 text-white text-sm disabled:opacity-60"
                        >
                          Modifier
                        </button>

                        <button
                          type="button"
                          disabled={isBusy}
                          onClick={() => archiveCategory(category)}
                          className="px-3 py-2 rounded-lg bg-gray-700 text-white text-sm disabled:opacity-60"
                        >
                          Archiver
                        </button>

                        <button
                          type="button"
                          disabled={isBusy}
                          onClick={() => deleteCategory(category)}
                          className="px-3 py-2 rounded-lg bg-red-600 text-white text-sm disabled:opacity-60"
                        >
                          Supprimer
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <form
        id="admin-shop-product-form"
        onSubmit={saveProduct}
        className="bg-white shadow-lg rounded-2xl p-4 md:p-6 mb-8 grid grid-cols-1 md:grid-cols-2 gap-4"
      >
        <div className="md:col-span-2 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <h2 className="text-xl font-bold text-gray-800">
            Ajouter / Modifier un produit
          </h2>

          <button
            type="button"
            onClick={resetProductForm}
            className="px-4 py-2 rounded-full bg-gray-200 text-gray-800 text-sm"
          >
            Vider le formulaire
          </button>
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">ID</label>
          <input
            name="id"
            type="number"
            value={productForm.id}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="60"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Ordre d’affichage</label>
          <input
            name="sortOrder"
            type="number"
            value={productForm.sortOrder}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="1"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-semibold mb-1">Nom</label>
          <input
            name="name"
            value={productForm.name}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="AT10 GENIUS..."
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Référence / SKU</label>
          <input
            name="sku"
            value={productForm.sku}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="NOX-AT10-12K"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Marque / Ligne</label>
          <input
            name="line"
            value={productForm.line}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="NOX"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Catégorie</label>
          <select
            name="categorySlug"
            value={productForm.categorySlug}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            required
          >
            {activeCategories.length === 0 ? (
              <option value="">Aucune catégorie</option>
            ) : (
              activeCategories.map((category) => (
                <option key={category.slug} value={category.slug}>
                  {category.name}
                </option>
              ))
            )}
          </select>
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Statut stock</label>
          <select
            name="stockStatus"
            value={productForm.stockStatus}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
          >
            <option value="available">Disponible</option>
            <option value="out_of_stock">Rupture</option>
            <option value="preorder">Précommande</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Prix</label>
          <input
            name="price"
            type="number"
            step="0.01"
            value={productForm.price}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="99.99"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Remise %</label>
          <input
            name="discountRatePercent"
            type="number"
            min="0"
            max="100"
            step="1"
            value={productForm.discountRatePercent}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="20"
          />
        </div>

        <div className="flex items-center gap-2">
          <input
            name="discountEligible"
            type="checkbox"
            checked={productForm.discountEligible}
            onChange={handleProductChange}
          />
          <label>Produit en promotion</label>
        </div>

        <div className="flex items-center gap-2">
          <input
            name="featured"
            type="checkbox"
            checked={productForm.featured}
            onChange={handleProductChange}
          />
          <label>Produit mis en avant</label>
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-semibold mb-1">Description</label>
          <textarea
            name="description"
            value={productForm.description}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2 min-h-[90px]"
            placeholder="Description courte du produit..."
          />
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Tailles</label>
          <input
            name="sizesText"
            value={productForm.sizesText}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2"
            placeholder="S, M, L, XL ou 39, 40, 41"
          />
          <p className="text-xs text-gray-500 mt-1">
            Sépare les tailles par des virgules. Laisse vide si pas de taille.
          </p>
        </div>

        <div>
          <label className="block text-sm font-semibold mb-1">Caractéristiques</label>
          <textarea
            name="featuresText"
            value={productForm.featuresText}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2 min-h-[90px]"
            placeholder={`🎯|Contrôle et précision\n⚡|Bonne sortie de balle`}
          />
          <p className="text-xs text-gray-500 mt-1">
            Une caractéristique par ligne. Format : emoji|texte.
          </p>
        </div>

        <div className="md:col-span-2 border rounded-xl p-4 bg-gray-50">
          <label className="block text-sm font-semibold mb-1">Image du produit</label>

          <input
            name="image"
            value={productForm.image}
            onChange={handleProductChange}
            className="w-full border rounded-lg p-2 bg-white"
            placeholder="raquette-at10.png ou URL Firebase Storage"
            required
          />

          <p className="text-xs text-gray-500 mt-1">
            Tu peux garder une image dans /public avec son nom de fichier, ou uploader une nouvelle image ci-dessous.
          </p>

          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImageFile(e.target.files?.[0] || null)}
            className="w-full border rounded-lg p-2 bg-white mt-3"
          />

          {imageFile && (
            <div className="mt-2 text-sm text-gray-700">
              Nouvelle image sélectionnée : <strong>{imageFile.name}</strong>
            </div>
          )}

          {productForm.image && (
            <div className="mt-3">
              <p className="text-xs text-gray-500 mb-1">Aperçu :</p>

              <img
                src={productForm.image}
                alt="Aperçu produit"
                className="w-48 h-48 object-contain rounded-lg border bg-white"
              />
            </div>
          )}
        </div>

        <div className="flex items-center gap-2">
          <input
            name="visible"
            type="checkbox"
            checked={productForm.visible}
            onChange={handleProductChange}
          />
          <label>Visible dans la boutique</label>
        </div>

        <div className="flex items-center gap-2">
          <input
            name="archived"
            type="checkbox"
            checked={productForm.archived}
            onChange={handleProductChange}
          />
          <label>Archivé</label>
        </div>

        <button
          type="submit"
          disabled={isBusy}
          className="md:col-span-2 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full py-3 font-semibold shadow-lg disabled:opacity-60"
        >
          {isBusy ? 'Enregistrement...' : 'Enregistrer le produit'}
        </button>
      </form>

      <div className="bg-white shadow-lg rounded-2xl p-4 md:p-6">
        <div className="flex flex-col md:flex-row gap-3 md:items-center md:justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-800">
            Produits dans shop_products
          </h2>

          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border rounded-lg p-2 w-full md:w-80"
            placeholder="Recherche ID, nom, catégorie, SKU..."
          />
        </div>

        {loadingProducts ? (
          <p className="text-gray-500">Chargement...</p>
        ) : filteredProducts.length === 0 ? (
          <p className="text-gray-500">
            Aucun produit trouvé dans shop_products.
          </p>
        ) : (
          <div className="space-y-3">
            {filteredProducts.map((product) => {
              const finalPrice = priceAfterDiscount(product);

              return (
                <div
                  key={getProductDocId(product)}
                  className={`border rounded-xl p-4 ${
                    product.archived ? 'bg-gray-100 opacity-70' : 'bg-white'
                  }`}
                >
                  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <div className="flex gap-4">
                      {product.image && (
                        <img
                          src={product.image}
                          alt={product.name}
                          className="hidden sm:block w-24 h-24 object-contain rounded-lg border bg-gray-50"
                        />
                      )}

                      <div>
                        <div className="font-bold text-lg text-[#4c2f8e]">
                          #{product.id} - {product.name}
                        </div>

                        <div className="text-sm text-gray-600 mt-1">
                          {product.category || getCategoryName(product.categorySlug)} | {product.line || 'Sans marque'} | {statusLabel[product.stockStatus] || product.stockStatus}
                        </div>

                        {product.sku && (
                          <div className="text-xs text-gray-500 mt-1">
                            SKU : {product.sku}
                          </div>
                        )}

                        <div className="text-sm mt-1">
                          Prix : {Number(product.price || 0).toFixed(2)} €
                          {product.discountEligible && (
                            <>
                              {' '}→ <strong>{finalPrice.toFixed(2)} €</strong>
                              {' '}({Number(product.discountRate || 0) * 100}%)
                            </>
                          )}
                        </div>

                        {Array.isArray(product.sizes) && product.sizes.length > 0 && (
                          <div className="text-xs text-gray-500 mt-1">
                            Tailles : {product.sizes.join(', ')}
                          </div>
                        )}

                        <div className="text-xs text-gray-500 mt-1 break-all">
                          Image : {product.image || 'Aucune'}
                        </div>

                        <div className="text-xs text-gray-500 mt-1">
                          Ordre : {product.sortOrder || product.id} | Visible : {product.visible ? 'oui' : 'non'} | Archivé : {product.archived ? 'oui' : 'non'}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        disabled={isBusy}
                        onClick={() => editProduct(product)}
                        className="px-3 py-2 rounded-lg bg-blue-600 text-white text-sm disabled:opacity-60"
                      >
                        Modifier
                      </button>

                      <button
                        type="button"
                        disabled={isBusy}
                        onClick={() => duplicateProduct(product)}
                        className="px-3 py-2 rounded-lg bg-green-600 text-white text-sm disabled:opacity-60"
                      >
                        Dupliquer
                      </button>

                      <button
                        type="button"
                        disabled={isBusy}
                        onClick={() => toggleProductVisibility(product)}
                        className="px-3 py-2 rounded-lg bg-yellow-500 text-white text-sm disabled:opacity-60"
                      >
                        {product.visible ? 'Masquer' : 'Afficher'}
                      </button>

                      <button
                        type="button"
                        disabled={isBusy}
                        onClick={() => archiveProduct(product)}
                        className="px-3 py-2 rounded-lg bg-gray-700 text-white text-sm disabled:opacity-60"
                      >
                        Archiver
                      </button>

                      <button
                        type="button"
                        disabled={isBusy}
                        onClick={() => deleteProduct(product)}
                        className="px-3 py-2 rounded-lg bg-red-600 text-white text-sm disabled:opacity-60"
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl text-yellow-800 text-sm">
        Conseil : utilise plutôt “Archiver” que “Supprimer” si un produit a déjà été commandé.
      </div>
    </div>
  );
};

export default AdminShopCatalog;